import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useEffect, useMemo} from 'react'
import {branch, compose} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {NullAsDefault} from 'views/Shared'
import {withReportTable} from 'views/Workspace/Examination/renderReportTable'
import {useRouteSearchParam} from "../../../../envs/_current/history";
import {course_getStudentById_Api, course_getStudentResultReport_Api} from "../../../../apis";
import Translate from "../../../../modules/local/Translate";
import {getResponseItem, renderIf, renderIfElse} from "../../../Shared";
import {ifThenElseMultipleConditions} from "../../../../helpers/ifThenElseMultipleConditions";
import {bindQueryParam} from "../../../AppLocals/functions/routerHelper";
import useAsync from "../../../../modules/asyncCache/useAsync";
import {StudentResultReportFilter} from "../components/filters/StudentResultReportFilter";
import {useLocation} from "react-use";
import {HeaderWithIconLine} from "../../../AppLocals/Templates/items/ListHeader";
import {BsInfoCircleFill} from "react-icons/bs";
import {ItemInformation} from "../../../AppLocals/Organization/OrganizationEntity";
import getTitle from "../../../../helpers/getTitle";
import getAliasName from "../../../../helpers/getAliasName";
import getLabelOfGender from "../../../../helpers/getLabelOfGender";
import {DoubleValueItem} from "../../../AppLocals/CatholicHousehold/components/CatholicHouseholdComponents";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {Link} from "react-router-dom";
import {GoDotFill} from "react-icons/go";
import classNames from "classnames";
import {TbSum} from "react-icons/tb";
import DrawDialog from "../../../../components/drawer/dialog/DrawDialog";
import {RiEye2Line} from "react-icons/ri";
import {formatDate} from "../../../../helpers/datetimeHelpers";

const headers = [
    'subject name',
    'cc_percent',
    'score weight',
    'score',
    'final_status',
    'title of course'
]

const schemas = [
    {
        name: 'subject_name',
        value_path: 'subject_name',
        className: 'font-medium text-color-000 whitespace-no-wrap',
    },
    {
        name: 'cc_percent',
        value_path: 'cc_percent',
        className: 'text-color-100',
        render: (value, data) => (
            <Translate>
                {t => (
                    renderIfElse(
                        value === null || value === undefined,
                        <span className="font-normal text-xs text-color-400 italic capitalize">{t('not update')}</span>,
                        <span className="font-semibold text-xs text-color-000">{`${value} %`}</span>
                    )
                )}
            </Translate>
        ),
    },
    {
        name: 'score_weight',
        value_path: 'score_weight',
        className: 'text-color-200',
        render: (value, data) => <span className="text-xs">{value}</span>,
    },
    {
        name: 'score_number',
        value_path: 'score_number',
        className: 'text-color-100',
        render: (value, data) => {
            let score = value;
            switch (_.get(data, 'score_type')) {
                case "text":
                    score = _.get(data, 'score_text')
                    break;
                default:
                    score = _.get(data, 'score_number')
                    break;
            }
            return (
                <Translate>
                    {t => (
                        renderIfElse(
                            value === null || value === undefined,
                            <span
                                className="font-normal text-xs text-color-400 italic capitalize">{t('not update')}</span>,
                            <div className="flex flex-center space-x-2">
                                <span className="font-semibold text-xs text-color-000">{value}</span>
                                <DrawDialog
                                    width={600}
                                    title={
                                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                                            {t('grades detail')}
                                        </div>
                                    }
                                    closable={true}
                                    component={<RiEye2Line size={14}
                                                           className="text-color-500 hover:text-color-100 cursor-pointer"/>}>
                                    {(isToggle, toggle) => isToggle && (
                                        <div className="flex flex-col gap-2">
                                            <HeaderWithIconLine
                                                title="list of grades"
                                                className="text-sm text-color-400"
                                            />
                                            <div className="ml-1 space-y-3">
                                                {_.get(data, 'grades', []).map((e, i) => {
                                                    const {
                                                        grade_title,
                                                        score_type,
                                                        score_number,
                                                        score_1_number,
                                                        score_2_number,
                                                        score_text,
                                                        score_1_text,
                                                        score_2_text,
                                                        grade_date,
                                                        grade_1_date,
                                                        grade_2_date,
                                                    } = e ?? {}

                                                    return (
                                                        <div key={i}
                                                             className="py-1 flex flex-col gap-1 custom-render-border">
                                                            <span
                                                                className="font-bold text-sm text-color-000 leading-snug">{grade_title}</span>
                                                            <div
                                                                className="grid grid-cols-1 md:grid-cols-2 gap-x-2 gap-y-1">
                                                                <DoubleValueItem
                                                                    showIcon={true}
                                                                    labelFirst={`${t('score times')} 1`}
                                                                    valueFirst={renderIfElse(
                                                                        score_type === 'text',
                                                                        score_text,
                                                                        score_number
                                                                    )}
                                                                    labelSecond=" - "
                                                                    valueSecond={formatDate(grade_date, 'DD/MM/YYYY')}
                                                                    className="text-xs italic"
                                                                />
                                                                {renderIf(
                                                                    grade_1_date,
                                                                    <DoubleValueItem
                                                                        showIcon={true}
                                                                        labelFirst={`${t('score times')} 2`}
                                                                        valueFirst={renderIfElse(
                                                                            score_type === 'text',
                                                                            score_1_text,
                                                                            score_1_number
                                                                        )}
                                                                        labelSecond=" - "
                                                                        valueSecond={formatDate(grade_1_date, 'DD/MM/YYYY')}
                                                                        className="text-xs italic"
                                                                    />
                                                                )}
                                                                {renderIf(
                                                                    grade_2_date,
                                                                    <DoubleValueItem
                                                                        showIcon={true}
                                                                        labelFirst={`${t('score times')} 3`}
                                                                        valueFirst={renderIfElse(
                                                                            score_type === 'text',
                                                                            score_2_text,
                                                                            score_2_number
                                                                        )}
                                                                        labelSecond=" - "
                                                                        valueSecond={formatDate(grade_2_date, 'DD/MM/YYYY')}
                                                                        className="text-xs italic"
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    )}
                                </DrawDialog>
                            </div>
                        )
                    )}
                </Translate>
            )
        },
    },
    {
        name: 'result_status',
        value_path: 'result_status',
        render: (value, data) => (
            <Translate>
                {t => (
                    <div className="ml-1 space-y-1 mt-1">
                        {ifThenElseMultipleConditions(
                            <span
                                className="font-normal text-xs text-color-400 italic capitalize">{t('not update')}</span>,
                            value === 1, <span className="font-bold text-sm text-green-600">{t('passed')}</span>,
                            value === 0, <span className="font-medium text-sm text-primary-500">{t('failed')}</span>,
                            value === -1, <span className="text-sm text-color-200">{t('pending')}</span>
                        )}
                    </div>
                )}
            </Translate>
        ),
    },
    {
        name: 'course_name',
        value_path: 'course_name',
        className: 'font-medium text-blue-700 italic flex items-start justify-start',
    },
]


const StudentResultReport = ({
                                 owner_id,
                                 owner_type,
                                 filter_actions = {
                                     sortBy: 'sort-by',
                                     keyword: 'keyword',
                                     student_id: 'student-id',
                                 },
                             }) => {
    const t = useTranslate()

    const location = useLocation()

    const apiInfo = course_getStudentById_Api
    const sortBy = useRouteSearchParam(filter_actions.sortBy)

    const student_id = useRouteSearchParam(filter_actions.student_id)

    const {response, isLoading = false, handleAsyncAction} = useAsync({
        apiInfo,
        query: bindQueryParam({id: student_id}),
    })

    const student = getResponseItem(response)

    useEffect(() => {
        handleAsyncAction({}, {id: student_id})
    }, [student_id])

    const refresh_deps = useMemo(
        () => [
            owner_id,
            owner_type,
            student_id,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [owner_id, owner_type, student_id, location.state]
    )

    const course_students = _.get(student, 'course_students', [])

    const {fullname, student_idcode, date_of_birth, gender, contact_phone, contact_email} = student ?? {}

    const [pager_widget, {widget_header}] = usePaginationHelper({
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onSortChange(sortBy)
            onFilterChange({
                student_id
            })
        },
        pagerInfo: {
            query: bindQueryParams([
                {id: owner_id}, {type: owner_type}, {student_id},
            ]),
            PaginationMeta: NullAsDefault,
            apiInfo: course_getStudentResultReport_Api,
            ...withReportTable(headers, schemas),
        },
        withKey: createPagerKey(refresh_deps),
        dependencies: [owner_id, owner_type, student_id],
        filter_params: {
            owner_id,
            owner_type,
            student_id,
        },
        renderSortBy: NullAsDefault,
        SortByWidget: NullAsDefault,
        renderSearchBar: NullAsDefault,
        isToggleDefault: true,
        query_params: filter_actions,
        AdvancedFilter: StudentResultReportFilter,
        renderHeader: ([searchBar, filterBar]) => (
            <div className="flex flex-col gap-3 mt-6">
                {filterBar}
                {renderIf(
                    student?.fullname,
                    <div className="flex flex-col gap-4 mb-6">
                        {renderIf(
                            !_.isEmpty(student?.fullname),
                            <div className="w-full flex flex-col gap-2">
                                <HeaderWithIconLine
                                    icon={<BsInfoCircleFill size={14} className="text-color-500 mr-1"/>}
                                    title="student information"
                                    className="text-sm text-color-400"
                                />
                                <div className="ml-3 flex flex-col gap-1">
                                    <ItemInformation
                                        primary={true}
                                        showIcon={true}
                                        label="name of the student"
                                        value={`${getAliasName(student, 'patron_saint') || ''} ${fullname} `}
                                        className="text-xs"/>
                                    <ItemInformation
                                        showIcon={true}
                                        label="student code"
                                        value={`#${student_idcode}`}
                                        className="text-xs italic"/>
                                    <DoubleValueItem
                                        showIcon={true}
                                        labelFirst="date of birth"
                                        valueFirst={date_of_birth ? formatDate(date_of_birth, 'DD/MM/YYYY') : t('not update')}
                                        labelSecond={gender !== 0 ? ' - ' : ''}
                                        valueSecond={t(getLabelOfGender(gender))}
                                        className="text-xs italic"/>
                                    <DoubleValueItem
                                        showIcon={true}
                                        labelFirst="contact"
                                        valueFirst={contact_phone}
                                        labelSecond={contact_email ? ' - ' : ''}
                                        valueSecond={contact_email}
                                        className="text-xs italic"/>
                                </div>
                            </div>
                        )}
                        {renderIf(
                            course_students.length > 0,
                            <div className="w-full flex flex-col gap-2">
                                <HeaderWithIconLine
                                    icon={<TbSum size={14} className="text-color-500 mr-1"/>}
                                    title="academic results"
                                    className="text-sm text-color-400"
                                />
                                <div className="ml-3 flex flex-col gap-3">
                                    {course_students.map((e, i) => {
                                        const {course, registered_classes = [], result_status} = e ?? {}
                                        let label_status
                                        let color_status
                                        switch (result_status) {
                                            case 1:
                                                label_status = 'passed'
                                                color_status = 'text-green-600'
                                                break
                                            case 0:
                                                label_status = 'failed'
                                                color_status = 'text-red-600'
                                                break
                                            default:
                                                label_status = 'not assessed yet'
                                                color_status = 'text-color-300'
                                                break
                                        }

                                        return (
                                            <div key={i} className="py-2 flex flex-col custom-render-border relative">
                                                <Link target="_blank" to={getLinkToDetail(course)}
                                                      className="mb-1 font-bold text-sm text-blue-700 no-underline">
                                                    {getTitle(course)}
                                                </Link>
                                                <DoubleValueItem
                                                    showIcon={true}
                                                    labelFirst="time"
                                                    valueFirst={formatDate(course?.time_open, 'DD/MM/YYYY')}
                                                    labelSecond={course?.time_close ? ' - ' : ''}
                                                    valueSecond={formatDate(course?.time_close, 'DD/MM/YYYY')}
                                                    className="text-xs italic"
                                                />
                                                {renderIf(
                                                    registered_classes?.length,
                                                    <div className="space-x-1 text-xs italic">
                                                        <GoDotFill size={10} className="text-color-500"/>
                                                        <span
                                                            className="text-color-500 whitespace-no-wrap">{`${t('students of class')} : `}</span>
                                                        {registered_classes.map((e, i) => (
                                                            <Link key={i} to={getLinkToDetail(e)}
                                                                  className="font-semibold text-color-100 no-underline">
                                                                {getTitle(e)} {i < registered_classes.length - 1 && ', '}
                                                            </Link>
                                                        ))}
                                                    </div>
                                                )}
                                                <span
                                                    style={{top: 8, right: 8}}
                                                    className={classNames("absolute font-bold text-xs tracking-wide uppercase opacity-80", color_status)}>
                                                    {t(label_status)}
                                                </span>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        ),
    })
    return (
        <div className="space-y-3">
            <div className="font-semibold text-primary tracking-wide uppercase">
                {t('report')}
            </div>
            <div className="border rounded-lg p-3">
                <div className="flex flex-col">
                    <div className="text-center font-bold text-lg text-color-000 uppercase tracking-widest">
                        {t('detail report of student')}
                    </div>
                    {student_id ? pager_widget : widget_header}
                </div>
            </div>
        </div>
    )
}

export default compose(
    branch(
        ({owner_id, owner_type}) => _.some([owner_id, owner_type], _.isEmpty),
        () => () => <ContentNotFound/>
    )
)(StudentResultReport)
